import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "common-confirm-dialog-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "common-confirm-dialog-body"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "common-confirm-dialog-body"
}
const _hoisted_6 = { class: "common-confirm-dialog-footer" }

import { ElDialog, ElButton } from 'element-plus'
import { t } from '@/plugins/i18n'
import { ref, nextTick } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: true
  },
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  htmlNode: {
    type: Boolean,
    default: false
  },
  ok: {
    type: Function,
    default: () => { }
  },
  okText: {
    type: String,
    default: ''
  },
  cancelText: {
    type: String,
    default: ''
  },
  cancel: {
    type: Function,
    default: () => { }
  },
  width: {
    type: Number,
    default: 400
  }
},
  emits: ['ok', 'cancel'],
  setup(__props, { emit }) {

const props = __props


const submit = () => {
  props.ok()
}
const close = () => {
  props.cancel()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    "model-value": true,
    "show-close": false,
    width: __props.width,
    "custom-class": "common-confirm-dialog",
    "before-close": close,
    top: "0",
    "close-on-click-modal": __props.closeOnClickModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "iconfont icon-guanbi1",
          onClick: close
        }),
        _createElementVNode("div", {
          class: "common-confirm-dialog-title",
          innerHTML: __props.title
        }, null, 8, _hoisted_2),
        (__props.htmlNode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", { innerHTML: __props.text }, null, 8, _hoisted_4)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.text), 1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(ElButton), {
            type: "default",
            onClick: close,
            style: {"min-width":"80px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.cancelText || _unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: submit,
            style: {"min-width":"80px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.okText || _unref(t)('确定')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["width", "close-on-click-modal"]))
}
}

})